// @flow
import { connect } from 'react-redux';

// Components
import CreateProfileContent from './CreateProfileContent';

// Types
import type { State } from 'types/redux';
import type { Props } from './CreateProfileContent';

// Selectors
import { getAppFlow } from 'store/reducers/userInteractions/selectors';
import { getObfuscatedBy } from 'store/reducers/appointment/contactInfo/selectors';

const mapStateToProps = (state: State): $Shape<Props> => ({
  appFlow: getAppFlow(state),
  obfuscatedBy: getObfuscatedBy(state)
});

export default connect(mapStateToProps)(CreateProfileContent);



// WEBPACK FOOTER //
// ./src/components/pages/ConfirmationPage/CreateProfile/components/CreateProfileContent/CreateProfileContentContainer.js